import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import LogoMark from "@/components/LogoMark";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "The Shop", id: "#about" },
  { label: "What We Do", id: "#services" },
  { label: "The Work", id: "#work" },
  { label: "Contact", id: "#contact" },
];

export default function Footer() {
  return (
    <footer className="border-t border-bone/10 bg-ink">
      <div className="mx-auto max-w-[1600px] px-5 py-16 sm:px-8">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <a
              href="#top"
              data-testid="footer-logo-link"
              className="flex items-center gap-3"
              onClick={(e) => {
                e.preventDefault();
                scrollToId("#top");
              }}
            >
              <LogoMark className="h-14" />
              <span className="font-display text-3xl font-bold uppercase leading-none tracking-[0.02em] text-bone">
                Dreamworlds <span className="text-steel">Garage</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs font-display text-xl font-semibold uppercase tracking-wide text-bone/60">
              Mopar or no car.
            </p>
          </div>

          <nav className="flex flex-col gap-3" aria-label="Footer">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={l.id}
                data-testid={`footer-link-${l.id.replace("#", "")}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId(l.id);
                }}
                className="font-display text-xl font-semibold uppercase tracking-wide text-bone/70 transition-colors duration-200 hover:text-bone"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-4 text-bone/80">
            <a
              href="tel:+13528973160"
              data-testid="footer-phone-link"
              className="flex items-center gap-3 transition-colors hover:text-bone"
            >
              <Phone className="h-4 w-4 text-steel" /> (352) 897-3160
            </a>
            <a
              href="mailto:Dreamworldsgarage@gmail.com"
              data-testid="footer-email-link"
              className="flex items-center gap-3 break-all transition-colors hover:text-bone"
            >
              <Mail className="h-4 w-4 shrink-0 text-steel" />
              Dreamworldsgarage@gmail.com
            </a>
            <a
              href="https://maps.google.com/?q=3430+West+Dunnellon+Rd,+Dunnellon,+FL"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address-link"
              className="flex items-start gap-3 transition-colors hover:text-bone"
            >
              <MapPin className="mt-1 h-4 w-4 shrink-0 text-steel" />
              3430 West Dunnellon Rd, Dunnellon, FL
            </a>
            <a
              href="https://www.facebook.com/dreamworldsgarage/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="flex items-center gap-3 transition-colors hover:text-bone"
            >
              <Facebook className="h-4 w-4 text-steel" />
              facebook.com/dreamworldsgarage
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-bone/10 pt-6 text-xs uppercase tracking-[0.2em] text-bone/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Dreamworlds Garage LLC</p>
          <p>Family owned and operated — Dunnellon, FL</p>
        </div>
      </div>
    </footer>
  );
}
